<script lang="ts">
export default {
  name: 'YieldScoreColumn',
  props: {
    dataKey: String,
    translationKey: String,
    days: Number,
  },
};
</script>

<template>
  <Column :field="'plant.' + dataKey" style="width: 11rem" sortable>
    <template #header>
      {{ $t(`glossary.${translationKey}`) }}
      <help-icon
        :title="$t(`glossary.${translationKey}`)"
        :description="
          $t('features.performance_ratio.description', { nr_days: days })
        "
        link="https://support.sundata.nl/nl/articles/5422752-sundata-analyseert-verwachtingen-vs-daadwerkelijke-opbrengsten"
        class="ml-1"
      />
    </template>
    <template #body="slotProps">
      {{
        slotProps.data.plant[dataKey]
          ? parseFloat(slotProps.data.plant[dataKey]).toFixed(2)
          : null
      }}
    </template>
  </Column>
</template>

<style scoped></style>
